import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Addstaffs:[]
}

const AddstaffSlice = createSlice({
    name: "addstaff",
    initialState,
    reducers: {
        setAddstaff: (state, action) => {
            state.Addstaffs = action.payload;
        },

      
       
    }
});

export const { setAddstaff} = AddstaffSlice.actions;
export default AddstaffSlice.reducer;